<template>
  <component :is="is" :class="componentClass" :href="href" :type="computedType" :to="to" :target="target"
    :disabled="disabled">
    <base-icon v-if="icon" :path="icon" />
    <span v-if="effect"
      :class="`absolute w-0 h-0 transition-all duration-500 ease-out bg-${props.colorName}-700 rounded-full group-hover:w-56 group-hover:h-56 `"></span>
    <span v-if="effect"
      :class="`absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-50 bg-gradient-to-b from-transparent via-transparent to-${props.colorName}-700`"></span>

    <span v-if="label && effect" class="relative" :class="labelClass">{{ label }}</span>
    <span v-else :class="labelClass">{{ label }}</span>
  </component>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { getButtonColor } from '../colors.js'

const props = defineProps({
  label: {
    type: [String, Number],
    default: null
  },
  icon: {
    type: String,
    default: null
  },
  href: {
    type: String,
    default: null
  },
  target: {
    type: String,
    default: null
  },
  to: {
    type: [String, Object],
    default: null
  },
  type: {
    type: String,
    default: null
  },
  color: {
    type: String,
    default: 'white'
  },
  colorName: {
    type: String,
    default: 'teal'
  },
  as: {
    type: String,
    default: null
  },
  small: Boolean,
  outline: Boolean,
  active: Boolean,
  disabled: Boolean,
  effect: Boolean,
})

const is = computed(() => {
  if (props.as) {
    return props.as
  }

  if (props.to) {
    return 'router-link'
  }

  if (props.href) {
    return 'a'
  }

  return 'button'
})

const computedType = computed(() => {
  if (is.value === 'button') {
    return props.type ?? 'button'
  }

  return null
})

const labelClass = computed(() => props.small && props.icon ? 'px-1' : 'px-2')

const componentClass = computed(() => {
  let base = [
    'inline-flex',
    'cursor-pointer',
    'justify-center',
    'items-center',
    'whitespace-nowrap',
    'focus:outline-none',
    'transition-colors',
    'focus:ring',
    'duration-150',
    'border',
    'rounded',
    props.active ? 'ring ring-black dark:ring-white' : 'ring-blue-700',
    props.small ? 'p-1' : 'p-2',
    getButtonColor(props.color, props.outline, !props.disabled)
  ]

  if (props.disabled) {
    base.push('cursor-not-allowed', props.outline ? 'opacity-50' : 'opacity-70')
  }
  if (props.effect) {
    base = []
    base.push(props.small ? 'p-1' : 'p-2',
      'relative inline-flex items-center justify-center overflow-hidden font-mono font-medium tracking-tighter text-white bg-gray-800 rounded-lg group')
  }
  return base
})
</script>
